import budget from './budget.json'
import action from './action.json'
import permission from './permission.json'
import menu from './menu.json'
import company from './company.json'

import portuguese from './portuguese.json'

const exportedObject = {
  budget,
  action,
  menu,
  permission,
  company,
  ...portuguese
}

export default exportedObject;